<template>
  <div>
    <b-row>
      <b-col cols="2" class="m-0 p-0 sidemenu">
        <div class="sidemenu-item" v-if="user.isAdmin">
          <b-link :to="{ name: 'admin-dashboard-management' }"
            >Dashboard</b-link
          >
        </div>
        <div class="sidemenu-item" v-if="user.isAdmin || isInRole('TableauAdmin')">
          <b-link :to="{ name: 'admin-tableau-management' }"
          >Tableau Views</b-link
          >
        </div>
        <div class="sidemenu-item" v-if="user.isAdmin || isInRole('TableauAdmin')">
          <b-link :to="{ name: 'admin-tableau-permission' }"
          >Tableau Permission</b-link
          >
        </div>
        <div class="sidemenu-item" v-if="user.isAdmin">
          <b-link :to="{ name: 'admin-tableau-identities' }"
          >Tableau Identities</b-link
          >
        </div>
        <div class="sidemenu-item" v-if="user.isAdmin">
          <b-link :to="{ name: 'admin-smartgrabber-management' }"
          >SmartGrabber</b-link
          >
        </div>
        <div class="sidemenu-item" v-if="user.isAdmin">
          <b-link :to="{ name: 'admin-gbq-management' }"
          >GBQ</b-link
          >
        </div>
        <div class="sidemenu-item" v-if="user.isAdmin">
          <b-link :to="{ name: 'admin-cache-management' }"
          >Cache</b-link
          >
        </div>
        <div class="sidemenu-item" v-if="user.isAdmin">
          <b-link :to="{ name: 'admin-exception-logs' }"
          >Exception Logs</b-link
          >
        </div>
      </b-col>
      <b-col class="py-3 content-container">
        <router-view />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import application from '../../mixins/application';
export default {
  name: 'Admin',
  mixins: [application],
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
};
</script>

<style scoped>
.content-container {
  height: calc(100vh - 56px);
  overflow: auto;
}
.sidemenu {
  height: calc(100vh - 56px);
  overflow: auto;
  border-right: 1px solid #bebebe;
}

.sidemenu-item {
  padding: 10px 18px;
  border-bottom: 1px solid #bebebe;
  /*cursor: pointer;*/
}

.sidemenu-item:hover {
  /*background-color: #ebebeb;*/
}
</style>